<!--
 * @Author: lishiqiao
 * @Date: 2022-03-17 15:25:09
 * @LastEditors: lishiqiao
 * @LastEditTime: 2022-08-24 10:33:51
-->
<template>
  <div class="chart-slider" ref="slider" @click="jump" v-show="total > 7">
    <div
      class="chart-block"
      ref="block"
      @mousedown="blockDown"
      @click="stopPropagation"
    ></div>
  </div>
</template>

<script>
export default {
  name: "my-slider",
  data() {
    return {
      moveNum: 0,
      blockWidth: 50,
      startValue: -1,
    };
  },
  props: {
    total: Number,
  },
  mounted() {
    if (this.total > 7) {
      this.blockWidth = (7 / this.total) * 100;
      this.$refs["block"].style.width = this.blockWidth + "%";
      this.moveNum = this.total - 7;
    }
  },
  methods: {
    blockDown(event) {
      const sliderWidth = this.$refs["slider"].clientWidth; // 父元素宽度 包括内边距，不包括边框和滚动条
      const blockWidth = this.$refs["block"].clientWidth; // 滑块宽度 包括内边距，不包括边框和滚动条
      const x = event.x; // 鼠标按下x坐标
      const left = this.$refs["block"].style.left;
      const idx = left.indexOf("p");
      const leftVal = Number(left.slice(0, idx)); // 鼠标按下时left值
      document.onmousemove = (event1) => {
        const move = leftVal + event1.x - x; // 鼠标移动时滑块left值
        // 鼠标移动时滑块left值小于0时防止滑块超出父元素左边
        if (move <= 0) {
          this.$refs["block"].style.left = "0px";
          this.startValue = 0;
        } // 鼠标移动时滑块left值大于父元素最大值时防止滑块超出父元素右边
        else if (move >= sliderWidth - blockWidth) {
          this.$refs["block"].style.left = sliderWidth - blockWidth + "px";
          this.startValue = this.moveNum;
        } else {
          this.$refs["block"].style.left = move + "px";
          this.startValue = Math.round(
            move / (sliderWidth - blockWidth) / (1 / this.moveNum)
          );
        }
      };
      document.onmouseup = () => {
        document.onmousemove = null; // 移除鼠标移动事件
        document.onmouseup = null; // 移除鼠标弹起事件
      };
    },
    jump(event) {
      const move = event.offsetX - this.$refs["block"].clientWidth / 2;
      const sliderWidth = this.$refs["slider"].clientWidth; // 父元素宽度 包括内边距，不包括边框和滚动条
      const blockWidth = this.$refs["block"].clientWidth; // 滑块宽度 包括内边距，不包括边框和滚动条
      // 鼠标移动时滑块left值小于0时防止滑块超出父元素左边
      if (move <= 0) {
        this.$refs["block"].style.left = "0px";
        this.startValue = 0;
      } // 鼠标移动时滑块left值大于父元素最大值时防止滑块超出父元素右边
      else if (move >= sliderWidth - blockWidth) {
        this.$refs["block"].style.left = sliderWidth - blockWidth + "px";
        this.startValue = this.moveNum;
      } else {
        this.$refs["block"].style.left = move + "px";
        this.startValue = Math.round(
          move / (sliderWidth - blockWidth) / (1 / this.moveNum)
        );
      }
    },
    stopPropagation(event) {
      event = event || window.event;
      if (event.stopPropagation) {
        event.stopPropagation(); //W3C阻止冒泡方法
      } else {
        event.cancelBubble = true; //IE阻止冒泡方法
      }
    },
  },
  watch: {
    total() {
      if (this.total > 7) {
        this.blockWidth = (7 / this.total) * 100;
        this.$refs["block"].style.width = this.blockWidth + "%";
        this.moveNum = this.total - 7;
      }
    },
    startValue(value) {
      this.$emit("change", value);
    },
  },
};
</script>

<style lang="less" scoped>
.chart-slider {
  box-sizing: border-box;
  position: absolute;
  bottom: 35px;
  left: 0;
  right: 0;
  margin: auto;
  width: 60% !important;
  height: 6px !important;
  padding-top: 0 !important;
  border: 1px #46494a solid;
  border-radius: 3px;
  user-select: none;
  cursor: pointer;

  .chart-block {
    position: absolute;
    width: 10%;
    height: 100%;
    border-radius: 3px;
    background: #46494a;

    &:hover {
      background: #ab19f7;
    }
  }
}
</style>